/*
 * @Author: Diana Tang
 * @Date: 2025-06-25 14:18:06
 * @LastEditors: Diana Tang
 * @Description: some descriptio
 * @FilePath: /my-dataviz-website/src/index.js
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals